import React from 'react';

import _ from 'lodash';
import { Typography } from '@material-ui/core';

import styles from './PlayScore.module.scss';

const PlayScore = ({ play, game }) => {
  const home = { logo: _.get(game.home, 'logo'), score: play.homeScore };
  const away = { logo: _.get(game.away, 'logo'), score: play.awayScore };

  const reverse = game.homePosition === 'right';

  const renderTeam = ({ logo, score = 0 }) => (
    <div className={styles.team}>
      <Typography className={styles.score} align="center" variant="subtitle2">
        {score}
      </Typography>

      <div
        className={styles.logo}
        style={logo ? { backgroundImage: `url(${logo})` } : undefined}
      />
    </div>
  );

  return (
    <div className={styles.playScore}>
      {renderTeam(reverse ? away : home)}
      <Typography className={styles.vs} variant="subtitle2">
        -
      </Typography>
      {renderTeam(reverse ? home : away)}
    </div>
  );
};

export default PlayScore;
